import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var Token_BEGIN_ARRAY_instance;
var Token_END_ARRAY_instance;
var Token_BEGIN_OBJECT_instance;
var Token_END_OBJECT_instance;
var Token_NAME_instance;
var Token_STRING_instance;
var Token_NUMBER_instance;
var Token_LONG_instance;
var Token_BOOLEAN_instance;
var Token_NULL_instance;
var Token_END_DOCUMENT_instance;
var Token_ANY_instance;
var Token_entriesInitialized;
function Token_initEntries() {
  if (Token_entriesInitialized)
    return Unit_instance;
  Token_entriesInitialized = true;
  Token_BEGIN_ARRAY_instance = new (Token())('BEGIN_ARRAY', 0);
  Token_END_ARRAY_instance = new (Token())('END_ARRAY', 1);
  Token_BEGIN_OBJECT_instance = new (Token())('BEGIN_OBJECT', 2);
  Token_END_OBJECT_instance = new (Token())('END_OBJECT', 3);
  Token_NAME_instance = new (Token())('NAME', 4);
  Token_STRING_instance = new (Token())('STRING', 5);
  Token_NUMBER_instance = new (Token())('NUMBER', 6);
  Token_LONG_instance = new (Token())('LONG', 7);
  Token_BOOLEAN_instance = new (Token())('BOOLEAN', 8);
  Token_NULL_instance = new (Token())('NULL', 9);
  Token_END_DOCUMENT_instance = new (Token())('END_DOCUMENT', 10);
  Token_ANY_instance = new (Token())('ANY', 11);
}
var TokenClass;
function Token() {
  if (TokenClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'Token');
    TokenClass = $;
  }
  return TokenClass;
}
function Token_BEGIN_ARRAY_getInstance() {
  Token_initEntries();
  return Token_BEGIN_ARRAY_instance;
}
function Token_END_ARRAY_getInstance() {
  Token_initEntries();
  return Token_END_ARRAY_instance;
}
function Token_BEGIN_OBJECT_getInstance() {
  Token_initEntries();
  return Token_BEGIN_OBJECT_instance;
}
function Token_END_OBJECT_getInstance() {
  Token_initEntries();
  return Token_END_OBJECT_instance;
}
function Token_NAME_getInstance() {
  Token_initEntries();
  return Token_NAME_instance;
}
function Token_STRING_getInstance() {
  Token_initEntries();
  return Token_STRING_instance;
}
function Token_NUMBER_getInstance() {
  Token_initEntries();
  return Token_NUMBER_instance;
}
function Token_LONG_getInstance() {
  Token_initEntries();
  return Token_LONG_instance;
}
function Token_BOOLEAN_getInstance() {
  Token_initEntries();
  return Token_BOOLEAN_instance;
}
function Token_NULL_getInstance() {
  Token_initEntries();
  return Token_NULL_instance;
}
function Token_END_DOCUMENT_getInstance() {
  Token_initEntries();
  return Token_END_DOCUMENT_instance;
}
function Token_ANY_getInstance() {
  Token_initEntries();
  return Token_ANY_instance;
}
//region block: exports
export {
  Token_ANY_getInstance as Token_ANY_getInstance2w9n8tbewmx1b,
  Token_BEGIN_ARRAY_getInstance as Token_BEGIN_ARRAY_getInstance1m9zfq25cdud1,
  Token_BEGIN_OBJECT_getInstance as Token_BEGIN_OBJECT_getInstancebag7ch821q11,
  Token_BOOLEAN_getInstance as Token_BOOLEAN_getInstance1imjwvekoc8j,
  Token_END_ARRAY_getInstance as Token_END_ARRAY_getInstance3dpoufa7bg3im,
  Token_END_DOCUMENT_getInstance as Token_END_DOCUMENT_getInstanceq7szdjm8kumg,
  Token_END_OBJECT_getInstance as Token_END_OBJECT_getInstance3atpnap4azrkn,
  Token_LONG_getInstance as Token_LONG_getInstanceo364xilpufkq,
  Token_NAME_getInstance as Token_NAME_getInstance19jzx1o7f4ts5,
  Token_NULL_getInstance as Token_NULL_getInstance1sp8yn17d7412,
  Token_NUMBER_getInstance as Token_NUMBER_getInstance3h0qmmxij905,
  Token_STRING_getInstance as Token_STRING_getInstance1xe7h31onye8j,
};
//endregion

//# sourceMappingURL=JsonReader.mjs.map
